/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

export default countHolders;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/_countHolders.js
// module id = 3379
// module chunks = 0